"use strict";

exports.__esModule = true;
exports.HideXAxisFieldSelector = void 0;
var _react = _interopRequireDefault(require("react"));
var _helper = require("../helper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var HideXAxisFieldSelector = exports.HideXAxisFieldSelector = function HideXAxisFieldSelector(props) {
  return /*#__PURE__*/_react["default"].createElement(_helper.AxisControls, null, /*#__PURE__*/_react["default"].createElement(_helper.CheckboxEl, _extends({
    propName: "hideXAxis",
    defaultLabel: "Hide Axis"
  }, props)));
};